import { FC } from 'react';
import { ExperienceAnswerStep } from 'shared/models';
import { SourceIndex } from '../source-index';
import { useAtomValue } from 'jotai';
import { $UserAgent } from '@lemon8/web-app-shared/atom';

import './style.scss';

export const AnswerStepContent: FC<ExperienceAnswerStep> = ({ title, content, sourceList }) => {
  const { isBot } = useAtomValue($UserAgent);
  return (
    <li>
      <div className="answer-step-content">
        <strong>{title}: </strong>
        <span>{content} </span>
        {!isBot &&
          sourceList.map((sourceIndex) => {
            return <SourceIndex key={`source-index-${sourceIndex}}`} index={sourceIndex} />;
          })}
      </div>
    </li>
  );
};
